import React, { useCallback, useState } from 'react';

import Button from '@amzn/meridian/button';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import nda from 'src/images/nda.png';

import './amazonConfidentialityAgreementModal.scss';

const AmazonConfidentialityAgreementModal = () => {
  const [isUserAgreed, setIsUserAgreed] = useState(false);
  const [isScrolledOnce, setIsScrolledOnce] = useState(false);
  const [isNDALoaded, setIsNDALoaded] = useState(false);

  const handleScroll = useCallback((event: React.UIEvent<HTMLDivElement>) => {
    const target = event.currentTarget;
    const { scrollHeight, clientHeight, scrollTop } = target;
    const isScrolledToBottom = !(scrollHeight - clientHeight - 1 > scrollTop);
    if (isScrolledToBottom) {
      setIsScrolledOnce(true);
    }
  }, []);

  const handleUserAgreement = () => {
    localStorage.setItem('userAgreement', 'true');
    setIsUserAgreed(true);
    window.location.reload();
  };

  const handleImgLoad = () => {
    setIsNDALoaded(true);
  };

  return (
    <>
      {!isUserAgreed && !localStorage.getItem('userAgreement') && (
        <div id="nda-modal-container">
          <Modal
            title={'Amazon Confidentiality Agreement (Please scroll to the bottom to review and agree)'}
            open={true}
            width="700px"
            scrollContainer="modal"
          >
            <div className="nda-image-container" onScroll={handleScroll}>
              <img className="nda-image" src={nda} onLoad={() => handleImgLoad()} />
            </div>
            <ModalFooter>
              <Row widths="fill">
                {isNDALoaded && (
                  <Button
                    id="nda-modal-save-btn"
                    type="primary"
                    size="small"
                    onClick={handleUserAgreement}
                    disabled={!isScrolledOnce}
                  >
                    I Agree
                  </Button>
                )}
              </Row>
            </ModalFooter>
          </Modal>
        </div>
      )}
    </>
  );
};

export default AmazonConfidentialityAgreementModal;
